import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { catchError, Observable } from 'rxjs';

import { environment } from '@environment/environment';
import { PaginatedResponse } from '@models/paginated-resopnse.interface';
import { Log } from '../interfaces/log.interface';
import { PaginationRequestDto } from '../../core/dto/pagination-request.dto';
import { SearchMonitorDto } from '../dto/search-monitoring.interface';
import { ExceptionProvider } from '@providers/exception.provider';

@Injectable({ providedIn: 'root' })
export class LogService {
  private _httpClient = inject(HttpClient);
  private _exceptionProvider = inject(ExceptionProvider);

  private API_PATH = `${environment.apiBaseUrl}/v1/logs`;

  logError(error: any) {
    const errorPayload = {
      message: error.message || 'Error desconocido en cliente',
      stack: error.stack,
      url: window.location.href,
      userAgent: window.navigator.userAgent,
      timestamp: new Date().toISOString(),
    };
    this._httpClient.post(this.API_PATH, errorPayload).subscribe({
      error: () => console.warn('Falló el envío del log al servidor')
    });
  }

  getLogs(
    paginationRequestDto: PaginationRequestDto,
    searchMonitorDto: SearchMonitorDto
  ): Observable<PaginatedResponse<Log>> {
    searchMonitorDto.startDate = new Date(searchMonitorDto.startDate.setHours(0, 0, 0, 0));
    searchMonitorDto.endDate = new Date(searchMonitorDto.endDate.setHours(23, 59, 59, 999));

    const params: any = {
      page: paginationRequestDto.page?.toString() || '',
      limit: paginationRequestDto.limit?.toString() || '',
      startDate: searchMonitorDto.startDate.toISOString(),
      endDate: searchMonitorDto.endDate.toISOString(),
    };

    if (searchMonitorDto.userId) params.userId = searchMonitorDto.userId;
    if (searchMonitorDto.id) params.id = searchMonitorDto.id.toString();

    return this._httpClient.get<PaginatedResponse<Log>>(this.API_PATH, { params }).pipe(
      catchError((error: HttpErrorResponse) => this._exceptionProvider.handleGenricError(error))
    );
  }
}
